module.exports = __webpack_public_path__ + "img/sld_ch_2_t1_green.9bc12dd3.svg";